module.exports = __webpack_public_path__ + "img/glossary-dosya.140bb7f8.png";